import React, { useContext, Fragment } from 'react'
import { Typography } from '@material-ui/core'
import DatePickerRange from '../../../components/filters/DatePickerRange'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import moment from 'moment'
import { defaultFormatTimeZone } from '../../../utils/consts'

export default function DateRange (): JSX.Element {
  const { filters, setFilters } = useContext(EventsFiltersContext)
  const onChange = (initialDate: moment.Moment, finalDate: moment.Moment) => {
    setFilters({
      date: {
        initialDate: initialDate.format('YYYY-MM-DD'),
        finalDate: finalDate.format('YYYY-MM-DD'),
        ...defaultFormatTimeZone
      }
    })
  }

  return (
    <Fragment>
      <Typography id="discrete-slider-custom" gutterBottom>Período</Typography>
      <DatePickerRange
        defaultInitialValue={moment(filters.date?.initialDate)}
        defaultFinalValue={moment(filters.date?.finalDate)}
        onChange={onChange}
      />
    </Fragment>
  )
}
